<template>
  <div class="w-full">
    <Head title="Prośby o terminy" />
    <h1 class="mb-8 text-3xl font-bold">
      Prośby o terminy
    </h1>

    <div class="mb-6 flex items-center justify-between">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
      />
    </div>

    <div class="overflow-x-auto rounded-sm bg-white shadow-sm">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pb-4 pt-6">
              Kontakt
            </th>
            <th class="px-6 pb-4 pt-6">
              Specjalista
            </th>
            <th class="px-6 pb-4 pt-6">
              Usługa
            </th>
            <th class="px-6 pb-4 pt-6">
              Data
            </th>
            <th class="px-6 pb-4 pt-6" />
          </tr>
        </thead>
        <tbody v-if="booking_interests.data.length">
          <tr
            v-for="interest in booking_interests.data"
            :key="interest.id"
            class="hover:bg-gray-50"
          >
            <td class="border-t px-6 py-4">
              {{ interest.contact }}
            </td>
            <td class="border-t px-6 py-4">
              {{ interest.specialist_name || '—' }}
            </td>
            <td class="border-t px-6 py-4">
              <span class="whitespace-normal">{{ interest.service_name || '—' }}</span>
            </td>
            <td class="border-t px-6 py-4 text-sm text-gray-500">
              {{ formatDate(interest.created_at) }}
            </td>
            <td class="w-px border-t">
              <div class="flex shrink-0 items-center px-4">
                <button
                  type="button"
                  class="btn-action-delete"
                  title="Usuń"
                  @click="destroy(interest)"
                >
                  <icon name="trash" class="mr-1.5 h-3.5 w-3.5 stroke-current" />
                  Usuń
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="border-t px-6 py-4" colspan="5">
              Brak próśb o terminy.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination :meta="booking_interests.meta" />
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination.vue';
import pickBy from 'lodash/pickBy';
import SearchFilter from '@/Shared/SearchFilter.vue';
import throttle from 'lodash/throttle';
import { createLayoutHelper } from '@/utils/layoutHelper';

export default {
  components: {
    Head,
    Link,
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: createLayoutHelper,
  props: {
    booking_interests: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        search: this.filters.search || '',
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function handler() {
        this.$inertia.get(
          this.$routes.admin_booking_interests(),
          pickBy(this.form),
          { preserveState: true, replace: true },
        );
      }, 150),
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleString('pl-PL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    reset() {
      this.form = mapValues(this.form, () => '');
    },
    destroy(interest) {
      if (!confirm('Usunąć tę prośbę o termin?')) return;
      router.delete(this.$routes.admin_booking_interest(interest.id));
    },
  },
};
</script>
